import { jsx as r } from "react/jsx-runtime";
import n from "./context/Dom.js";
import t from "./context/WindowSize/WindowDimensionsProvider.js";
import "./context/WindowSize/Dimensions.js";
function u(o) {
  const e = n(o);
  return function({ children: i }) {
    return /* @__PURE__ */ r(e, { children: /* @__PURE__ */ r(t, { children: i }) });
  };
}
export {
  u as default
};
